import React, { CSSProperties, ReactNode, useState } from 'react';
import { useTheme } from 'styled-components';

import { AlertIcon, BlockIcon, CheckmarkIcon, CrossmarkIcon, InfoIcon } from 'assets/icons';
import { IconWrapper } from 'common/components';
import { AlertDescription, AlertWrapper } from 'common/components/Alert/WarningAlert.styled';

interface IWarningAlertProps {
  text: string | ReactNode;
  fontSize?: string;
  showCloseIcon?: boolean;
  margin?: string;
  additionalStyle?: CSSProperties;
  info?: boolean;
  confirmInfo?: boolean;
  error?: boolean;
  backgroundColor?: string;
  additionalContentOnRHS?: ReactNode;
  showAlertCustom?: boolean;
  blackWindow?: boolean;
  iconSize?: number;
  iconColor?: string;
  textColor?: string;
  customIcon?: ReactNode;
}

export const WarningAlert = ({
  text,
  fontSize,
  showCloseIcon = true,
  margin,
  additionalStyle,
  info = false,
  confirmInfo = false,
  error = false,
  backgroundColor,
  additionalContentOnRHS,
  showAlertCustom = true,
  blackWindow = false,
  iconSize = 24,
  iconColor,
  textColor,
  customIcon,
}: IWarningAlertProps) => {
  const [showAlert, setShowAlert] = useState(true);
  const { colors } = useTheme();

  return (
    <>
      {showAlert && showAlertCustom && (
        <AlertWrapper
          margin={margin}
          $additionalStyle={additionalStyle}
          $info={info}
          $confirmInfo={confirmInfo}
          $error={error}
          $backgroundColor={backgroundColor}
          $blackWindow={blackWindow}
        >
          {customIcon ? (
            customIcon
          ) : (
            <>
              {info && (
                <InfoIcon width={iconSize} height={iconSize} stroke={iconColor || colors.primary} />
              )}
              {!info && !confirmInfo && !error && !blackWindow && (
                <AlertIcon
                  width={iconSize}
                  height={iconSize}
                  stroke={iconColor || colors.warning_dark}
                />
              )}
              {confirmInfo && (
                <CheckmarkIcon
                  width={iconSize}
                  height={iconSize}
                  stroke={iconColor || colors.positive_dark}
                />
              )}
              {error && (
                <BlockIcon
                  width={iconSize}
                  height={iconSize}
                  stroke={iconColor || colors.negative_dark}
                />
              )}
            </>
          )}

          <AlertDescription $fontSize={fontSize} $textColor={textColor}>
            {text}
          </AlertDescription>

          {showCloseIcon && (
            <IconWrapper $stroke={colors.black_100} onClick={() => setShowAlert(false)}>
              <CrossmarkIcon />
            </IconWrapper>
          )}

          {additionalContentOnRHS && additionalContentOnRHS}
        </AlertWrapper>
      )}
    </>
  );
};
